/* BENUTE — inline size selection, native filter drawer and product rails. */
(() => {
  'use strict';
  if (window.__benuteAtelierLoaded) return;
  window.__benuteAtelierLoaded = true;
  const core = window.BenuteStudio;
  if (!core) return;
  const initialized = new WeakSet();
  let filterID = 0;

  function cards(scope) {
    if (!window.BenuteCart) return;
    scope.querySelectorAll('[data-bn-card-inline]').forEach(card => {
      if (initialized.has(card)) return;
      initialized.add(card);
      const choices = [...card.querySelectorAll('[data-bn-card-size]')];
      const panel = card.querySelector('[data-bn-card-choice]');
      const add = card.querySelector('[data-bn-card-add]');
      const status = card.querySelector('[data-bn-card-status]');
      const price = card.querySelector('[data-bn-card-price]');
      let selected = null, busy = false;
      const sync = () => {
        panel.setAttribute('aria-busy', String(busy));
        choices.forEach(button => {
          button.disabled = busy || !button.dataset.bnVariantId;
          button.setAttribute('aria-pressed', String(button === selected));
        });
        add.disabled = busy || !selected;
        add.textContent = busy ? 'Adicionando…' : !selected ? 'Escolha seu tamanho' : add.dataset.bnPreorder === 'true' ? 'Adicionar pré-venda' : 'Adicionar à sacola';
      };
      choices.forEach(button => button.addEventListener('click', () => {
        if (busy || !button.dataset.bnVariantId) return;
        selected = button;
        status.replaceChildren();
        card.classList.remove('has-error');
        price.replaceChildren();
        const amount = Number(button.dataset.bnVariantPrice);
        const compare = Number(button.dataset.bnVariantCompare);
        if (compare > amount) price.append(core.element('s', '', core.money(compare)));
        price.append(core.element('span', '', core.money(amount)));
        sync();
      }));
      add.addEventListener('click', async () => {
        if (busy || !selected) return;
        const variantID = Number(selected.dataset.bnVariantId);
        if (!Number.isSafeInteger(variantID) || variantID < 1) return;
        busy = true;
        status.replaceChildren();
        card.classList.remove('has-error');
        sync();
        try {
          await window.BenuteCart.add({ items: [{ id: variantID, quantity: 1 }] }, add);
          status.textContent = 'Peça adicionada à sacola.';
        } catch (error) {
          status.textContent = error.message || 'Confira sua sacola antes de tentar novamente.';
          const link = core.element('a', '', 'Ver sacola');
          link.href = window.routes?.cartUrl || core.base + 'cart';
          status.append(document.createTextNode(' '), link);
          card.classList.add('has-error');
        } finally { busy = false; sync(); }
      });
      panel.hidden = false;
      card.dataset.bnInlineReady = 'true';
      sync();
    });
  }

  function filters(scope) {
    if (!window.HTMLDialogElement?.prototype.showModal) return;
    scope.querySelectorAll('[data-bn-filters]').forEach(details => {
      if (initialized.has(details)) return;
      initialized.add(details);
      const summary = details.querySelector('summary');
      const panel = details.querySelector('.bn-filters__panel');
      if (!summary || !panel) return;
      const dialog = core.element('dialog', 'bn-drawer bn-filter-drawer');
      dialog.id = `BN-Filter-${++filterID}`;
      dialog.setAttribute('aria-label', 'Filtrar produtos');
      dialog.append(panel);
      details.after(dialog);
      details.open = false;
      details.dataset.bnEnhanced = 'true';
      summary.setAttribute('aria-haspopup', 'dialog');
      summary.setAttribute('aria-controls', dialog.id);
      summary.setAttribute('aria-expanded', 'false');
      panel.querySelector('[data-bn-close-filters]')?.setAttribute('data-bn-close-dialog', '');
      core.bindDialogs(dialog.parentElement);
      summary.addEventListener('click', event => {
        event.preventDefault();
        if (core.open(dialog, summary)) summary.setAttribute('aria-expanded', 'true');
      });
      dialog.addEventListener('close', () => summary.setAttribute('aria-expanded', 'false'));
      const count = panel.querySelectorAll('input[type=checkbox]:checked').length +
        [...panel.querySelectorAll('input[type=number]')].filter(input => input.value !== '').length;
      const badge = summary.querySelector('[data-bn-filter-count]');
      if (badge) badge.textContent = count ? `(${count})` : '';
    });
  }

  function rails(scope) {
    scope.querySelectorAll('[data-bn-rail]').forEach(rail => {
      if (initialized.has(rail)) return;
      initialized.add(rail);
      const track = rail.querySelector('[data-bn-rail-track]');
      const controls = rail.querySelector('.bn-rail-controls');
      const prev = rail.querySelector('[data-bn-rail-prev]');
      const next = rail.querySelector('[data-bn-rail-next]');
      if (!track || !prev || !next) return;
      const update = () => {
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        controls.hidden = max < 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      };
      const move = direction => {
        const width = track.firstElementChild?.getBoundingClientRect().width || track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 10;
        const step = Math.max(width + gap, Math.floor(track.clientWidth / (width + gap)) * (width + gap));
        track.scrollTo({ left: Math.max(0, Math.min(track.scrollWidth - track.clientWidth, track.scrollLeft + direction * step)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      // Native horizontal scrolling also works without JavaScript or a mouse.
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(() => { if (rail.isConnected) update(); else observer.disconnect(); });
        observer.observe(track);
        rail.addEventListener('bn:dispose', () => observer.disconnect(), { once: true });
      } else {
        window.addEventListener('resize', update);
        rail.addEventListener('bn:dispose', () => window.removeEventListener('resize', update), { once: true });
      }
      rail.closest('[data-bn-edits]')?.addEventListener('click', () => requestAnimationFrame(update));
      update();
    });
  }
  const init = scope => { cards(scope); filters(scope); rails(scope); };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('dialog[open]').forEach(dialog => core.close(dialog));
    event.target.querySelectorAll('[data-bn-rail]').forEach(rail => rail.dispatchEvent(new Event('bn:dispose')));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
